import { useState } from "react";
import { CopyOutlined } from "@ant-design/icons";

const CopyContent = ({ children, content, className = "" }: any) => {
    const [isHovering, setIsHovering] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(content || "");
    };

    return (
        <div
            className={`email ${className}`}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            style={{
                position: "relative",
                display: "inline-block",
                paddingRight: "24px",
            }}
        >
            {children}

            <span
                onClick={handleCopy}
                style={{
                    position: "absolute",
                    right: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    opacity: isHovering ? 1 : 0,
                    transition: "opacity 0.2s ease",
                    pointerEvents: isHovering ? "auto" : "none",
                }}
            >
        <CopyOutlined />
      </span>
        </div>
    );
};

export default CopyContent;
